export const OrderTabEnum = {
    DRAFTED: 'drafted',
    ENQUIRED: 'enquired',
    ORDERED: 'ordered',
    DELIVERED: 'delivered',
    CANCELED: 'canceled',
};

export type OrderTab = (typeof OrderTabEnum)[keyof typeof OrderTabEnum];

export const orderTabStateFilter = {
    drafted: ['DRAFT'],
    enquired: ['OPEN'],
    ordered: ['CLOSED'],
    delivered: ['CLOSED'],
    canceled: ['CANCELED', 'CLOSED'],
};

export const orderTabOfferStateFilter = {
    ordered: ['ORDER', 'CUSTOMER_ADJUSTED', 'SUPPLIER_ADJUSTED', 'CONFIRMED', 'ACKNOWLEDGED'],
    delivered: ['DELIVERED', 'DELIVERY_CONFIRMED', 'INVOICED'],
    canceled: ['CANCELED', 'QUOTE_CANCELED', 'ENQUIRY_CANCELED'],
};
